"use client";
import BackgroundHero from "~/app/_components/section/hero/backgroundHero";
import FaqSection from "~/app/_components/section/faq";
import ExploreServiceSection from "~/app/_components/pageSpecific/service/exploreServices";
import { FAQ_INSIGHTS_DATA } from "~/content/faq";
import {
  SERVICE_PERSONAL_ICON_LINK,
  SERVICE_SUPPORT_ICON_LINK,
  SERVICE_ACCOMMODATION_ICON_LINK,
  SERVICE_TRANSPORT_ICON_LINK,
  SERVICE_COMMUNITY_ICON_LINK,
} from "~/content/services";
import heroImg from "public/images/insights/insight-Main-page.png";
import CustomButton from "../_components/common/button";
import BlogArticleSection from "../_components/pageSpecific/insight/blogArticleSection";
import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "next/navigation";
import scrollToSection from "../_components/common/scrollToSection";
import { useNavigationController } from "../utils/navHelper";
import { Insights } from "~/content/navLinks";
import { INSIGHT_SECTION_CONSTANTS } from "../insights/INSIGHT_SECTION_CONSTANTS";
import ResourceSection from "../_components/pageSpecific/insight/resourceSection";
import { type ArticleListProps } from "../insights/page";

const InsightsPageLayout = ({
  allTags: { tags },
  articles,
}: ArticleListProps) => {
  const faqRef = useRef<HTMLDivElement | null>(null);
  const blogRef = useRef<HTMLDivElement | null>(null);
  const resourceRef = useRef<HTMLDivElement | null>(null);

  const searchParams = useSearchParams();
  const params = searchParams.get("state");
  const state: string | undefined = params as string | undefined;

  useEffect(() => {
    const refs = [
      { title: INSIGHT_SECTION_CONSTANTS.FAQ, ref: faqRef },
      { title: INSIGHT_SECTION_CONSTANTS.BLOG, ref: blogRef },
      { title: INSIGHT_SECTION_CONSTANTS.RESOURCE, ref: resourceRef },
    ];
    if (state) {
      scrollToSection(state, refs);
    }
  }, [state]);

  const { navOnClick } = useNavigationController();

  const [activeSection, setActiveSection] = useState<"blogs" | "resources">(
    "blogs",
  );

  return (
    <>
      <BackgroundHero
        title={<h1 className="mb-4 text-right md:mb-8">Articles</h1>}
        pretitle={
          <h2 className="text-resp-2xl mb-8 ml-auto w-full max-w-[20rem] text-right md:mb-12 md:max-w-[22rem] xl:mb-14">
            Discover our latest news, insights and customer stories below.
          </h2>
        }
        body={
          <div className="ml-auto flex max-w-[20rem] flex-col justify-end gap-3 md:max-w-[42rem] md:flex-row xl:max-w-[50rem]">
            {/* TO UPDATE: change Resource-NDIS and Blogs to work as filter once drupal content is ready*/}
            <CustomButton
              variant="secondary"
              className="md:w-1/3"
              onClick={() => {
                setActiveSection("resources");
                navOnClick(Insights.href, INSIGHT_SECTION_CONSTANTS.RESOURCE);
              }}
            >
              Resource – NDIS
            </CustomButton>
            <CustomButton
              variant="secondary"
              className="md:w-1/3"
              onClick={() => {
                setActiveSection("blogs");
                navOnClick(Insights.href, INSIGHT_SECTION_CONSTANTS.BLOG);
              }}
            >
              Blogs
            </CustomButton>
            <CustomButton
              variant="secondary"
              className="md:w-1/3"
              onClick={() => {
                navOnClick(Insights.href, INSIGHT_SECTION_CONSTANTS.FAQ);
              }}
            >
              FAQs
            </CustomButton>
          </div>
        }
        bodyWidth="w-full"
        bgImage={heroImg}
        bgImageFit="auto"
        imageOpacity="opacity-60 lg:opacity-100"
        bgImagePosition="left"
        padding="pb-16 pt-[5.2rem] xs:pb-20 xs:pt-16 md:py-16 lg:py-24 xl:py-28"
      />

      {activeSection === "blogs" && (
        <BlogArticleSection
          ref={blogRef}
          {...{ allTags: { tags }, articles }}
        />
      )}
      {activeSection === "resources" && <ResourceSection ref={resourceRef} />}

      <FaqSection theme="dark" items={FAQ_INSIGHTS_DATA} ref={faqRef} />
      <ExploreServiceSection
        theme="light"
        items={[
          SERVICE_PERSONAL_ICON_LINK,
          // SERVICE_SUPPORT_ICON_LINK,
          SERVICE_ACCOMMODATION_ICON_LINK,
          SERVICE_COMMUNITY_ICON_LINK,
          SERVICE_TRANSPORT_ICON_LINK,
        ]}
      />
    </>
  );
};

export default InsightsPageLayout;
